export const emptyAddress = {
  address_type: "OFFICE",
  line1: "",
  line2: "",
  city: "",
  state: "",
  country: "India",
  pincode: "",
  is_default: false,
};

export const emptyTax = {
  tax_type: "GST",
  registration_no: "",
  state_code: "",
  is_active: true,
};

export const emptyBank = {
  bank_name: "",
  account_number: "",
  ifsc: "",
  is_default: false,
};

export const emptyContact = {
  name: "",
  designation: "",
  department: "",
  mobile: "",
  email: "",
  is_primary: false,
  is_active: true,
};

export const emptyPartner = {
  code: "",
  name: "",
  partner_type: "ORGANIZATION",
  status: "ACTIVE",
  roles: [],
  addresses: [],
  contacts: [],   // ✅ REQUIRED
  taxes: [],
  banks: [],
};
